var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"alt":"","src":require(`@/v1/assets/images/${_vm.src}.png`)}}),_c('strong',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }